import { authApi, ontruckApi } from './instances';

import * as config from 'config';

const convertToken = async token => {
  const { data } = await authApi.post('convert-token/', {
    grant_type: 'convert_token',
    client_id: config.ONTRUCK_AUTH_CLIENTID,
    token,
    backend: 'google-oauth2'
  });

  return data;
};

const revokeToken = async token => {
  await authApi.post('revoke-token/', {
    client_id: config.ONTRUCK_AUTH_CLIENTID,
    token
  });
};

const refreshToken = async token => {
  await authApi.post('token/', {
    client_id: config.ONTRUCK_AUTH_CLIENTID,
    grant_type: 'refresh_token',
    token: token
  });
};

const fetchMe = async () => {
  return await ontruckApi.get(`users/me/`);
};

const setAuthHeaders = async (tokenType, accessToken) => {
  ontruckApi.defaults.headers.common.Authorization = `${tokenType} ${accessToken}`;
  return ontruckApi;
};

export { convertToken, revokeToken, refreshToken, fetchMe, setAuthHeaders };
